import { apiClient } from '@shared/utils/api-client';
import type {
  ClientSupportMessage,
  ClientSupportMessagesResponse,
  ClientSupportThreadSummary,
  ClientSupportThreadsResponse,
  ClientSupportUserSearchItem,
} from '../types';

export const CLIENT_SUPPORT_CHAT_MAX_IMAGES = 5;

export const clientSupportChatApi = {
  getUnreadCount: () =>
    apiClient.get<{ count: number }>('/client-support-chat/admin/unread-count'),

  listThreads: (params?: { limit?: number; offset?: number }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.offset != null) search.set('offset', String(params.offset));
    const q = search.toString();
    return apiClient.get<ClientSupportThreadsResponse>(
      `/client-support-chat/admin/threads${q ? `?${q}` : ''}`,
    );
  },

  searchUsers: (q: string) => {
    const search = new URLSearchParams();
    search.set('q', q);
    return apiClient.get<ClientSupportUserSearchItem[]>(
      `/client-support-chat/admin/users/search?${search.toString()}`,
    );
  },

  ensureThread: (userId: number) =>
    apiClient.post<ClientSupportThreadSummary>(
      `/client-support-chat/admin/users/${userId}/thread`,
      {},
    ),

  getMessages: (userId: number, params?: { limit?: number; beforeId?: number }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.beforeId != null) search.set('beforeId', String(params.beforeId));
    const q = search.toString();
    return apiClient.get<ClientSupportMessagesResponse>(
      `/client-support-chat/admin/users/${userId}/messages${q ? `?${q}` : ''}`,
    );
  },

  sendMessage: async (userId: number, body: string, images?: File[]) => {
    const formData = new FormData();
    const trimmed = body.trim();
    if (trimmed) formData.append('body', trimmed);
    if (images && images.length > 0) {
      images.forEach((file) => formData.append('images', file));
    }
    return apiClient.post<ClientSupportMessage>(
      `/client-support-chat/admin/users/${userId}/messages`,
      formData,
    );
  },

  resolveOrderProblem: (userId: number, messageId: number) =>
    apiClient.post<ClientSupportMessage>(
      `/client-support-chat/admin/users/${userId}/order-problem/${messageId}/resolve`,
      {},
    ),

  inviteSeller: (userId: number, messageId: number) =>
    apiClient.post<ClientSupportMessage>(
      `/client-support-chat/admin/users/${userId}/order-problem/${messageId}/invite-seller`,
      {},
    ),

  markRead: (userId: number) =>
    apiClient.patch<{ ok: boolean; marked: number }>(
      `/client-support-chat/admin/users/${userId}/read`,
      {},
    ),
};
